import React from 'react';

interface PlayPauseButtonProps {
    isPlaying: boolean;
    onToggle: () => void;
}

const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({ isPlaying, onToggle }) => {
    return (
        <button
            onClick={onToggle}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '14px 24px',
                borderRadius: '8px',
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: isPlaying ? '#dc3545' : '#28a745',
                color: 'white',
                border: 'none',
                //borderRadius: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                minWidth: '140px',
                height: '70px',
                justifyContent: 'center'
            }}
        >
            {isPlaying ? '⏸️ Pause' : '▶️ Play'}
        </button>
    );
};

export default PlayPauseButton;